import React, { useState, useEffect } from 'react';

const CountdownTimer = ({ totalTimeLeft, onTimeUpdate }) => {
    const [count, setCount] = useState(totalTimeLeft);

    useEffect(() => {
        // 如果倒计时结束，就不再设置定时器
        if (count === 0) {
            onTimeUpdate(count);
            return;
        }

        // 设置定时器
        const intervalId = setInterval(() => {
            setCount(count => count - 1);
        }, 1000);

        // 清理定时器
        return () => clearInterval(intervalId);
    }, [count, onTimeUpdate]);

    return (
        <div style={{ margin: "10px 0", lineHeight: '30px' }}>Jump to homepage in {count} seconds</div>
    );
};

export default CountdownTimer;